var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-container',[_c('el-header',{staticStyle:{"height":"50px","padding-top":"10px"}},[_c('el-page-header',{on:{"back":_vm.goBack}},[_c('slots',{attrs:{"name":"content"}},[_vm._v("ddd")])],1)],1),_c('el-main',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }